import { EClientPermissions } from '@Enum/auth.enum'
import ClientLayout from '@Layouts/Client/ClientLayout'
import React from 'react'
import { connect } from 'react-redux'

import { Route, Redirect } from 'react-router-dom'

interface IClientRoute {
    exact?: boolean
    path?: string
    user?: any
    component: any
}

const ClientRoute: React.FC<IClientRoute> = ({
    component: Component,
    user,
    exact,
    path,
}) => {
    return (
        <Route
            exact={exact}
            path={path}
            render={(props: any) => {
                if (user?.permissions?.includes(EClientPermissions.LOGIN)) {
                    return (
                        <ClientLayout>
                            <Component {...props} />{' '}
                        </ClientLayout>
                    )
                }
                return (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: {
                                from: props.location,
                            },
                        }}
                    />
                )
            }}
        />
    )
}

const mapStateToProps = (state: any) => {
    const { user } = state?.auth

    return {
        user,
    }
}

export default connect(mapStateToProps, null)(ClientRoute)
